import { object, string } from 'yup'

export const partialAppSchema = (agentsFlagOn: boolean) => {
  const validationShape = {
    name: string()
      .required(`Enter a name for your ${agentsFlagOn ? 'agent' : 'app'}`)
      .min(2, `${agentsFlagOn ? 'Agent' : 'App'} name must be at least 2 characters`),
    description: string()
      .trim()
      .max(300, `${agentsFlagOn ? 'Agent' : 'App'} description must be less than 300 characters`)
      .required(`${agentsFlagOn ? 'Agent' : 'App'} description is required`),
    iconUrl: string()
      .trim()
      .required(`${agentsFlagOn ? 'Agent' : 'App'} icon is required`)
  } as any

  return object().shape(validationShape)
}
